import { ExpandMore } from "@mui/icons-material";
import {
  Box,
  FormControl,
  Grid2,
  MenuItem,
  Select,
  TableCell,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CommonButton from "../../../../component/Button";
import CommonTextField from "../../../../component/Input";
import {
  StyledFlexColumnView,
  StyledFlexRowView,
} from "../../../common-components/StyledComponents";
import { StyledSpaceBetweenBox } from "../../../matches/quick-match/components/StyledComponent";
import AddTeamMemberPopup from "../../sow-enrichment-copy/components/AddTeamMemeberPopup";
import CommonTable from "./CommonTable";

function DesiredCompositionTableList({
  isEdit,
  handleClickVerify,
  mileStonesTableData,
  formData,
  handleCloseDialog,
  handleClickAddTeam,
  handleChangeText,
  handleChange,
  openDialog,
  handleAddTeam,
  handleRecLevelStatusChange,
  handleMileLoctionStatusChange,
  totalCost,
}) {
  const [selectedRows, setSelectedRows] = useState([]);
  // const [openDialog, setOpenDialog] = useState(false);
  const [sortedData, setSortedData] = useState([
    {
      id: "100",
      team: "Salesforce Project Manager",
      cost: "$200",
      reqLevel: "Senior",
      req: "1",
      recLevel: "Junior",
      rec: "0.75",
      location: "Onsite",
      allocation: "100%",
    },
    {
      id: "101",
      team: "Salesforce Business Analyst/Administrator",
      cost: "$2500",
      reqLevel: "Senior",
      req: "1",
      recLevel: "Senior",
      rec: "0.2",
      location: "India",
      allocation: "100%",
    },
    {
      id: "102",
      team: "Salesforce Developer",
      cost: "$6000",
      reqLevel: "Mid-Level",
      req: "2",
      recLevel: "Mid-Level",
      rec: "1.5",
      location: "Hybrid",
      allocation: "100%",
    },
    {
      id: "103",
      team: "Salesforce Architect",
      cost: "$2000",
      reqLevel: "Mid-Level",
      req: "1",
      recLevel: "Mid-Level",
      rec: "0.5",
      location: "India",
      allocation: "100%",
    },
    {
      id: "104",
      team: "Salesforce Quality Assurance Analyst",
      cost: "$150",
      reqLevel: "Mid-Level",
      req: "1",
      recLevel: "Mid-Level",
      rec: "1",
      location: "Romania",
      allocation: "100%",
    },
    {
      id: "105",
      team: "DevOps Personnel",
      cost: "$150",
      reqLevel: "NA",
      req: "1",
      recLevel: "Mid-Level",
      rec: "0.5",
      location: "India",
      allocation: "100%",
    },
  ]);
  // const [mileStonesTableData, setMileStonesTableData] = useState([
  //   {
  //     id: "100",
  //     team: "Salesforce Project Manager",
  //     cost: "$200",
  //     reqLevel: "Jesse Matthews - 92%",
  //     req: "1",
  //     recLevel: "Junior",
  //     rec: "0.75",
  //     location: "Onsite",
  //     allocation: "75%",
  //   },
  //   {
  //     id: "101",
  //     team: "Salesforce Business Analyst/Administrator",
  //     cost: "$2500",
  //     reqLevel: "NA",
  //     req: "1",
  //     recLevel: "Senior",
  //     rec: "0.2",
  //     location: "India",
  //     allocation: "20%",
  //   },
  //   {
  //     id: "102",
  //     team: "Salesforce Developer",
  //     cost: "$6000",
  //     reqLevel: "NA",
  //     req: "1",
  //     recLevel: "Mid-Level",
  //     rec: "1.5",
  //     location: "Hybrid",
  //     allocation: "100%",
  //   },
  //   {
  //     id: "103",
  //     team: "Salesforce Architect",
  //     cost: "$2000",
  //     reqLevel: "Sushir Singh - 96%",
  //     req: "1",
  //     recLevel: "Mid-Level",
  //     rec: "0.5",
  //     location: "India",
  //     allocation: "50%",
  //   },
  //   {
  //     id: "104",
  //     team: "Salesforce Quality Assurance Analyst",
  //     cost: "$150",
  //     reqLevel: "NA",
  //     req: "1",
  //     recLevel: "Mid-Level",
  //     rec: "1",
  //     location: "Romania",
  //     allocation: "60%",
  //   },
  //   {
  //     id: "105",
  //     team: "DevOps Personnel",
  //     cost: "$150",
  //     reqLevel: "NA",
  //     req: "1",
  //     recLevel: "Mid-Level",
  //     rec: "0.5",
  //     location: "India",
  //     allocation: "20%",
  //   },
  // ]);

  // const [formData, setFormData] = useState({
  //   designation: "",
  //   seniority: "",
  //   resourceCount: "",
  //   hrs: "",
  //   location: "",
  // });

  // const handleChangeText = (field) => (event) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     [field]: event.target.value,
  //   }));
  // };

  // const handleChange = (field, value) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     [field]: value,
  //   }));
  // };

  // Track the index of the row being dragged
  const [draggedIndex, setDraggedIndex] = useState(null);

  const handleDragStart = (index) => {
    setDraggedIndex(index);
  };

  const handleDragEnter = (targetIndex) => {
    if (draggedIndex !== null && draggedIndex !== targetIndex) {
      const updatedData = [...sortedData];
      const [draggedRow] = updatedData.splice(draggedIndex, 1);
      updatedData.splice(targetIndex, 0, draggedRow);
      setSortedData(updatedData);
      setDraggedIndex(targetIndex);
    }
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
  };

  const headerData = [
    "Title",
    "Seniority",
    "Allocation",
    "Location",
    "Quantity",
  ];
  const mileStonesHeaderData = [
    "Title",
    "Seniority",
    "Allocation",
    "Location",
    "Quantity",
    "Cost",
    // "",
  ];

  const statusOptions = [
    { label: "Junior", color: "#9E77ED" },
    { label: "Mid-Level", color: "#F04438" },
    { label: "Senior", color: "#17B26A" },
    { label: "NA", color: "#A0A0A0" },
  ];

  const locationOptions = [
    { label: "India", color: "#9E77ED" },
    { label: "Romania", color: "#F04438" },
    { label: "Hybrid", color: "#F04438" },
    { label: "Onsite", color: "#17B26A" },
  ];

  const handleStatusChange = (event, rowId) => {
    const newStatus = event.target.value;
    setSortedData((prevData) =>
      prevData.map((row) =>
        row.id === rowId ? { ...row, reqLevel: newStatus } : row
      )
    );
  };

  const handleLocationStatusChange = (event, rowId) => {
    const newStatus = event.target.value;
    setSortedData((prevData) =>
      prevData.map((row) =>
        row.id === rowId ? { ...row, location: newStatus } : row
      )
    );
  };

  const handleTableBodyData = (row, index) => {
    return (
      <>
        {/* <TableCell>{row.id}</TableCell> */}
        <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
          {row.team}
        </TableCell>
        <TableCell>
          <FormControl>
            <Select
              value={row.reqLevel || ""}
              displayEmpty
              onChange={(event) => handleStatusChange(event, row.id)} // Handle change
              renderValue={(selected) => {
                const selectedOption = statusOptions.find(
                  (option) => option.label === selected
                );

                if (!selectedOption) {
                  return (
                    <Typography sx={{ color: "#A0A0A0" }}>
                      Select Level
                    </Typography>
                  );
                }

                return (
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: selectedOption.color,
                        marginRight: "8px",
                      }}
                    />
                    <Typography>{selectedOption.label}</Typography>
                  </Box>
                );
              }}
              IconComponent={ExpandMore}
              sx={{
                "& .MuiSelect-select": {
                  paddingLeft: "10px !important",
                  paddingTop: "1px !important",
                  paddingBottom: "1px !important",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "6px",
                  paddingRight: "25px !important",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#D0D5DD",
                  boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                },
                "& .MuiSelect-icon": {
                  fontSize: "14px",
                },
              }}
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.label} value={option.label}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: option.color,
                        marginRight: "8px",
                      }}
                    />
                    {option.label}
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </TableCell>
        <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
          {row.allocation}
        </TableCell>

        <TableCell>
          <FormControl>
            <Select
              value={row.location || ""}
              displayEmpty
              onChange={(event) => handleLocationStatusChange(event, row.id)} // Handle change
              renderValue={(selected) => {
                const selectedOption = locationOptions.find(
                  (option) => option.label === selected
                );

                if (!selectedOption) {
                  return (
                    <Typography sx={{ color: "#A0A0A0" }}>
                      Select Level
                    </Typography>
                  );
                }

                return (
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: selectedOption.color,
                        marginRight: "8px",
                      }}
                    />
                    <Typography>{selectedOption.label}</Typography>
                  </Box>
                );
              }}
              IconComponent={ExpandMore}
              sx={{
                "& .MuiSelect-select": {
                  paddingLeft: "10px !important",
                  paddingTop: "1px !important",
                  paddingBottom: "1px !important",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "6px",
                  paddingRight: "25px !important",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#D0D5DD",
                  boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                },
                "& .MuiSelect-icon": {
                  fontSize: "14px",
                },
              }}
            >
              {locationOptions.map((option) => (
                <MenuItem key={option.label} value={option.label}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: option.color,
                        marginRight: "8px",
                      }}
                    />
                    {option.label}
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </TableCell>

        <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
          {row.req}
        </TableCell>
        {/* <TableCell
          draggable
          onDragEnd={handleDragEnd}
          onDragStart={() => handleDragStart(index)}
          onDragEnter={() => handleDragEnter(index)}
          style={{
            cursor: "move",
            // backgroundColor: draggedIndex === index ? "#f0f0f0" : "transparent",
          }}
        >
          <IconButton>
            <DotsGrid />
          </IconButton>
        </TableCell> */}
      </>
    );
  };

  const handleMilesTableBodyData = (row, index) => {
    return (
      <>
        {/* <TableCell>{row.id}</TableCell> */}
        <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
          {row.team}
        </TableCell>
        <TableCell>
          <FormControl>
            <Select
              value={row.recLevel || ""}
              displayEmpty
              onChange={(event) => handleRecLevelStatusChange(event, row.id)} // Handle change
              renderValue={(selected) => {
                const selectedOption = statusOptions.find(
                  (option) => option.label === selected
                );

                if (!selectedOption) {
                  return (
                    <Typography sx={{ color: "#A0A0A0" }}>
                      Select Level
                    </Typography>
                  );
                }

                return (
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: selectedOption.color,
                        marginRight: "8px",
                      }}
                    />
                    <Typography>{selectedOption.label}</Typography>
                  </Box>
                );
              }}
              IconComponent={ExpandMore}
              sx={{
                "& .MuiSelect-select": {
                  paddingLeft: "10px !important",
                  paddingTop: "1px !important",
                  paddingBottom: "1px !important",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "6px",
                  paddingRight: "25px !important",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#D0D5DD",
                  boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                },
                "& .MuiSelect-icon": {
                  fontSize: "14px",
                },
              }}
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.label} value={option.label}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: option.color,
                        marginRight: "8px",
                      }}
                    />
                    {option.label}
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </TableCell>
        <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
          {row.allocation}
        </TableCell>
        <TableCell>
          <FormControl>
            <Select
              value={row.location || ""}
              displayEmpty
              onChange={(event) => handleMileLoctionStatusChange(event, row.id)} // Handle change
              renderValue={(selected) => {
                const selectedOption = locationOptions.find(
                  (option) => option.label === selected
                );

                if (!selectedOption) {
                  return (
                    <Typography sx={{ color: "#A0A0A0" }}>
                      Select Level
                    </Typography>
                  );
                }

                return (
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: selectedOption.color,
                        marginRight: "8px",
                      }}
                    />
                    <Typography>{selectedOption.label}</Typography>
                  </Box>
                );
              }}
              IconComponent={ExpandMore}
              sx={{
                "& .MuiSelect-select": {
                  paddingLeft: "10px !important",
                  paddingTop: "1px !important",
                  paddingBottom: "1px !important",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "6px",
                  paddingRight: "25px !important",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#D0D5DD",
                  boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                },
                "& .MuiSelect-icon": {
                  fontSize: "14px",
                },
              }}
            >
              {locationOptions.map((option) => (
                <MenuItem key={option.label} value={option.label}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: option.color,
                        marginRight: "8px",
                      }}
                    />
                    {option.label}
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </TableCell>
        <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
          {row.req}
        </TableCell>
        <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
          {row.cost}
        </TableCell>
        {/* <TableCell>
          <DotsVerticalIco />
        </TableCell> */}
        {/* <TableCell>
          <StatusChange>
            <DotColor
              color={
                row.reqLevel === "Jesse Matthews - 92%"
                  ? "#17B26A"
                  : row.status === "SalesForce BA"
                  ? "#9E77ED"
                  : row.status === "Available" || row.status === "Active"
                  ? "green"
                  : "#F04438"
              }
            />
            {row.reqLevel}
             <IconButton sx={{ padding: 0 }}>
              <ChevronDownIco width={"16px"} height={"16px"} />
            </IconButton> 
          </StatusChange>
        </TableCell> */}
      </>
    );
  };

  const handleRowCheckboxChange = (rowId) => {
    setSelectedRows((prevSelectedRows) =>
      prevSelectedRows.includes(rowId)
        ? prevSelectedRows.filter((id) => id !== rowId)
        : [...prevSelectedRows, rowId]
    );
  };

  // const handleCloseDialog = () => {
  //   setOpenDialog(false);
  //   setFormData({
  //     designation: "",
  //     senority: "",
  //     resourceCount: "",
  //     hrs: "",
  //     location: "",
  //   });
  // };

  // const handleClickAddTeam = () => {
  //   setOpenDialog(true);
  // };

  // const handleAddTeam = () => {
  //   const newTeamMember = {
  //     id: (mileStonesTableData.length + 100).toString(),
  //     team: formData.designation,
  //     cost: "$$$$",
  //     recLevel: formData.seniority,
  //     resources: formData.resourceCount,
  //     hrs: formData.hrs,
  //     reqLevel: "NA",
  //     location: formData?.location,
  //   };

  //   setMileStonesTableData((prevData) => [...prevData, newTeamMember]);
  //   handleCloseDialog();
  // };

  const formattedTotalCost = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(totalCost);

  return (
    <Grid2 container spacing={4}>
      <Grid2 size={12}>
        <StyledFlexRowView style={{ gap: "30px" }}>
          <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
            {"Desired Team"}
          </Typography>
          <CommonButton
            variant="contained"
            color="white"
            background="#7F56D9"
            fontWeight="700"
            value="Mark as verified"
            padding="8px 15px"
            onClick={handleClickVerify}
          />
        </StyledFlexRowView>
      </Grid2>
      <Grid2 size={12}>
        <CommonTable
          data={sortedData}
          columns={headerData}
          // sortedColumns={sortableColumns}
          onSortChange={(col) => console.log("Sort by", col)}
          onRowCheckboxChange={handleRowCheckboxChange}
          handleTableBodyData={handleTableBodyData}
          //   withCheckbox={true}
          marginTop={"0px"}
        />
      </Grid2>

      <Grid2 size={12}>
        <StyledSpaceBetweenBox>
          <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
            {"Recommended Team"}
          </Typography>
          {/* {isEdit ? ( */}
          <CommonButton
            variant="outlined"
            color="#344054"
            border="#D0D5DD"
            fontWeight="700"
            value="Add Member"
            padding="8px 15px"
            // disabled={isLoading}
            onClick={handleClickAddTeam}
            boxShadow={"0px 1px 2px 0px rgba(16, 24, 40, 0.05)"}
          />
          {/* ) : null} */}
        </StyledSpaceBetweenBox>
      </Grid2>

      <Grid2 size={12}>
        <CommonTable
          data={mileStonesTableData}
          columns={mileStonesHeaderData}
          // sortedColumns={sortableColumns}
          onSortChange={(col) => console.log("Sort by", col)}
          onRowCheckboxChange={handleRowCheckboxChange}
          handleTableBodyData={handleMilesTableBodyData}
          withCheckbox={true}
          marginTop={"0px"}
        />
      </Grid2>

      <Grid2 size={12}>
        <StyledSpaceBetweenBox>
          <div></div>
          <StyledFlexColumnView>
            <CommonTextField
              value={formattedTotalCost}
              disabled={true}
              padding={"12px"}
              // sx={{ width: "120px !important" }}
              // width={"120px !important"}
              customStyle={{ width: "200px !important" }}
            />

            <Typography
              sx={{ color: "#17B26A", fontSize: "14px", fontWeight: 500 }}
            >
              {"Within Range"}
            </Typography>
          </StyledFlexColumnView>
        </StyledSpaceBetweenBox>
      </Grid2>

      <AddTeamMemberPopup
        openDialog={openDialog}
        handleCloseDialog={handleCloseDialog}
        handleChangeText={handleChangeText}
        handleChange={handleChange}
        formData={formData}
        handleAddTeam={handleAddTeam}
        isLocation={true}
      />
    </Grid2>
  );
}

export default DesiredCompositionTableList;
